import { render, staticRenderFns } from "./DesktopFeaturedCard.vue?vue&type=template&id=ef5a7752&"
import script from "./DesktopFeaturedCard.vue?vue&type=script&lang=js&"
export * from "./DesktopFeaturedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports